import React from 'react';
import { TrendingUp } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  TypeGroup: string;
}

const FRSoldeGestion: React.FC<TypeReportProps> = ({ Entete, TypeGroup }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Solde de gestion"
      icon={<TrendingUp />}
      endpoint="solde-gestion"
      extraParams={{ Type: TypeGroup }}
      showClientRange={false}
      showDateRange={true}
      showAgence={true}
      extraFields={[
        {
          key: 'ListGroup',
          label: 'Sélection caisse',
          type: 'multiselect',
          fetchUrl: 'client-typegroupeclient',
          fetchParams: { TypeGroup },
          valueField: 'Code',
          labelField: 'Libelle',
          joinParam: 'ListGroup',
        },
        {
          key: 'Longueur',
          label: 'Format regroupement',
          type: 'select',
          defaultValue: '0',
          options: [
            { value: '0', label: 'DETAILLEE' },
            { value: '1', label: 'LONGEUR 1' },
            { value: '2', label: 'LONGEUR 2' },
            { value: '3', label: 'LONGEUR 3' },
            { value: '4', label: 'LONGEUR 4' },
            { value: '5', label: 'LONGEUR 5' },
            { value: '6', label: 'LONGEUR 6' },
            { value: '7', label: 'LONGEUR 7' },
            { value: '8', label: 'LONGEUR 8' },
            { value: '9', label: 'LONGEUR 9' },
            { value: '10', label: 'LONGEUR 10' },
          ],
        },
      ]}
      paramTransform={(params) => ({
        ...params,
        Min: Number(params.Longueur) || 0,
        Max: Number(params.Longueur) || 0,
      })}
      fileNamePrefix="rapport_solde_gestion"
    />
  );
};

export default FRSoldeGestion;
